<template>
    <div class="mt-5">
        <editor-js
            :data="data.text.content"
            @save="(d) => save(0, d)"
        />

        <div class="image-tools pt-0 pl-4 pr-4 pb-4">
            <hr />
            <div class="pl-4">
                <div class="columns">
                    <div class="column">
                        <b-button @click="mediaPicker=true"><i class="far fa-image mr-2"></i>Choose Photo</b-button>
                        <div class="columns mt-5">

                            <div class="column">
                                <b-field label="Photo Position" label-position="inside">
                                    <b-select expanded v-model="data.image.attributes.position">
                                        <option value="right">Right of Text</option>
                                        <option value="left">Left of Text</option>
                                        <option value="above">Above Text</option>
                                        <option value="below">Below Text</option>
                                    </b-select>
                                </b-field>
                            </div>
                            <div class="column">
                                <b-field label="Photo Width" label-position="inside">
                                    <b-select expanded v-model="data.image.attributes.width">
                                        <option :value="100">Full (100%)</option>
                                        <option :value="50">Half (50%)</option>
                                        <option :value="35">Third (35%)</option>
                                        <option :value="25">Quarter (25%)</option>
                                    </b-select>
                                </b-field>
                            </div>
                            <div class="column">
                                <b-switch v-model="data.image.attributes.wrap">Wrap Text</b-switch>
                            </div>
                        </div>
                    </div>
                    <div class="column is-narrow">
                        <div class="photo-frame"><img :src="data.image.content"  /></div>
                    </div>
                </div>

            </div>
        </div>

        <media-picker class="library" type="PHOTO" @choose="chooseMedia" @close="mediaPicker=false" v-if="mediaPicker"></media-picker>

    </div>
</template>

<script>
    import EditorJs from "../EditorJs.vue";
    import MediaPicker from "../../../cards/media_library/MediaPicker.vue";

    export default {
        components: {EditorJs, MediaPicker},
        props: ['data'],
        data: function () {
            return {
                mediaPicker: false,
            };
        },
        methods: {
            save(column, data) {
                this.data.text.content = data;
            },
            chooseMedia: function (media) {
                this.mediaPicker = false;

                this.data.image.content = media.url;
            }
        },
        created() {
            if (!this.data.text) {
                this.data.text = {content: null, attributes: {}};
                this.data.image = {content: null, attributes: {position: 'right', width: 35, wrap: false}}
            }
        }
    };
</script>

<style scoped lang="scss">
    .text-column {
        position: relative;
        flex: 1 1 50%;
    }

    .photo-frame {
        border-radius: 5px;
        margin: 1rem;
        border: 1px solid #e7e7e7;
        padding: 10px;
        width: 220px;
        line-height: 0;

        img {
            padding: 0;
            margin: 0;
            border-radius: 3px;
            width: 100%;
        }
    }
</style>
